<template>
  <div class="card-form">
    <PageTable
      :loading="loading"
      :tableData="tableData"
      :tablePage="page"
      @reload="reload"
      @checkbox-change="(e) => $emit('checkbox-change', e)"
    >
      <PageHeader
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
      />
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </PageTable>
  </div>
</template>
<script>
import PageHeader from './header.vue'
import PageTable from './table.vue'
import BaseTable from '@/mixins/base-table'
import { request } from '@/api/service'
export default {
  mixins: [BaseTable],
  components: { PageTable, PageHeader },
  props: { scmCode: { type: String, default: '' } },
  data() {
    return { usePage: true }
  },
  methods: {
    getData(form) {
      if (!this.scmCode) return
      this.loading = true
      const params = { scmCode: this.scmCode, ...form, ...this.page }
      request({
        url: '/ecom/hx/sku/listByFty',
        method: 'POST',
        data: params,
      })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
  },
}
</script>
